Number.prototype.pad = function () {
  return this.toString().length < 2 ? "0" + this : this;
};

// window.addEventListener("load", function () {
// if ($("#register-page")) {
//   const vm = new Vue({
//     el: "#register-page",
//     data: {
//       showCountVariants: [10, 20, 30, 40, 50],
//       selectedShowCountVariantsId: 0,
//       viewTypes: ["list", "grid"],
//       selectedViewType: "list",
//       regionVariants: ['Все регионы РФ', 'Татарстан', 'Башкортостан', 'Москва', 'Санкт-Петербург'],
//       selectedRegionVariantsId: 0,
//       subjectsSONKOVariants: ['Все субъекты', '1', '2', '3', '4'],
//       selectedSubjectsSONKOVariantsId: 0,
//       isFilterBlockOpened: false
//     },
//     watch: {
//       selectedViewType: function() {
//         $("table").colResizable();
//       }
//     },
//     mounted() {
//       this.$nextTick(() => {
//         $("table").colResizable();
//       });
//     },
//   });
// }
// });

// Vue.component("custom-select", {
//   props: {
//     selectOptions: {
//       type: String,
//       required: true,
//     },
//     selectedId: {
//       type: Number,
//       required: false,
//     },
//     callback: {
//       type: Function,
//       required: false,
//     },
//   },
//   data: function () {
//     return {
//       isOpened: false,
//     };
//   },
//   template: `
//     <div
//       :class="{'custom-select-opened' : isOpened}"
//       class="custom-select"
//     >
//       <div
//         @click="() => isOpened = !isOpened"
//         class="select-current"
//       >
//         {{ selectOptions[selectedId] }}
//           <svg class="select-current__icon"><use xlink:href="/assets/img/sprite.svg#chevron-down"></svg>
//       </div>
//       <div class="select-list">
//           <div
//             v-for="(option, index) in selectOptions"
//             :key="'index'+'option'"
//             @click="() => {
//               if (callback)
//                 callback(index);
//               isOpened = false;
//             }"
//             :class="{'select-option-selected' : (index == selectedId) }"
//             class="select-option"
//           >
//             {{ option }}
//           </div>
//       </div>
//     </div>`,

//   mounted() {
//     // this.$nextTick(() => {
//     //   this.selectId = this.selectedId;
//     // });
//   },
// });

$(document).ready(function () {
  setTimeout(function () {
    (wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: !0,
      live: !0,
      callback: function (box) {
        if (box.classList.contains("js-anim-num")) {
          animateNumber($(box).find(".js-num-el"), $(box).data("js-num"));
        }
      },
    })),
      wow.init();
  }, 200);

  $(".team-slider").slick({
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: !1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
});

$(document).ready(function () {
  initCaseSlider();
  function initCaseSlider() {
    const caseSlider = document.querySelector(".case-slider"),
      caseSliderCounter = document.querySelector(".slider-counter"),
      slideImageCount = document.querySelectorAll(
        ".case-slider .slide__img-block"
      ).length;

    if (caseSlider) {
      $(caseSlider).on(
        "init reInit afterChange",
        function (event, slick, currentSlide, nextSlide) {
          let i = (currentSlide ? currentSlide : 0) + 1;

          caseSliderCounter.textContent =
            (slick.slideCount == i ? slideImageCount.pad() : (i * 8).pad()) +
            " / " +
            slideImageCount.pad();
        }
      );

      $(caseSlider).slick({
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      });
    }
  }
});

$(document).ready(function () {
  initMoreCases();
  function initMoreCases() {
    const moreCasesSlider = document.querySelector(".more-cases-slider");
    if (moreCasesSlider) {
      $(moreCasesSlider).slick({
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    }
  }
});

// const n = document.querySelector("#clientAnim"),
//   i = document.querySelector("#brandBtn");
// n.addEventListener("animationend", function () {
//   i.classList.add("brand--inverse");
// }),
//   i.addEventListener("animationend", function () {
//     setTimeout(function () {
//       i.classList.remove("brand--inverse"),
//         i.classList.remove("brand--highlighted");
//     }, 0);
//   });

function animateNumber($el, numberValue) {
  $({ numberValue: 0 }).animate(
    { numberValue },
    {
      duration: 3000,
      // duration: 3000 / 123 * numberValue,
      easing: "linear",
      step: function () {
        $el.text(Math.ceil(this.numberValue));
      },
    }
  );
}

// слайдер во весь экран
$(document).ready(function () {
  initSlickFullscreen();

  function initSlickFullscreen() {
    const fullscreen = document.querySelector(".slick-fullscreen");

    if (fullscreen) {
      fullscreen.remove();
      document.body.appendChild(fullscreen);

      const closeFullscreenBtn = fullscreen.querySelector(
          '[data-js="close-slick-fullscreen"]'
        ),
        slider = fullscreen.querySelector(".slick-fullscreen__slider"),
        btnsToOpenSlickFullscreen = document.querySelectorAll(
          '[data-js="open-slick-fullscreen"]'
        );

      closeFullscreenBtn.addEventListener("click", function () {
        fullscreen.classList.remove("slick-fullscreen-opened");
      });

      btnsToOpenSlickFullscreen.forEach(function (el) {
        el.addEventListener("click", function () {
          fullscreen.classList.add("slick-fullscreen-opened");

          const slickId = el.getAttribute("data-slick-id");
          setTimeout(() => {
            if (!slider.classList.contains("slick-initialized")) {
              $(slider).slick({
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
              });
            }
            $(slider).slick("slickGoTo", slickId);
          }, 10);
        });
      });
    }
  }
});
// !слайдер во весь экран
